import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

/**
 * AccessDenied — shown when a user navigates to a route they don't have permission for.
 */
export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        px: 2,
        textAlign: "center",
        animation: "fadeIn 0.4s ease-out",
        "@keyframes fadeIn": {
          from: { opacity: 0, transform: "translateY(20px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      {/* Icon Container */}
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #fef2f2, #fee2e2)",
          border: "2px solid #fecaca",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 8px 30px rgba(220, 38, 38, 0.15)",
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 48, color: "#DC2626" }} />
      </Box>

      {/* Status Code */}
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "4rem", md: "6rem" },
          fontWeight: 800,
          background: "linear-gradient(135deg, #DC2626, #ef4444)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: 1,
        }}
      >
        403
      </Typography>

      {/* Title */}
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: "text.primary", mb: -1 }}
      >
        Access Denied
      </Typography>

      {/* Message */}
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          maxWidth: 400,
          lineHeight: 1.7,
        }}
      >
        You don&apos;t have permission to view this page. Please contact your
        administrator to get access.
      </Typography>

      {/* Back Button */}
      <Button
        variant="contained"
        onClick={() => navigate("/dashboard")}
        sx={{
          mt: 1,
          px: 4,
          py: 1.2,
          background: "linear-gradient(135deg, #DC2626, #ef4444)",
          borderRadius: "10px",
          fontWeight: 600,
          textTransform: "none",
          fontSize: "0.95rem",
          boxShadow: "0 4px 15px rgba(220, 38, 38, 0.3)",
          "&:hover": {
            background: "linear-gradient(135deg, #b91c1c, #DC2626)",
            boxShadow: "0 6px 20px rgba(220, 38, 38, 0.4)",
            transform: "translateY(-1px)",
          },
          transition: "all 0.2s ease",
        }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
}
